'use client';

import { ExternalLink, Heart } from 'lucide-react';
import { Company } from '@/lib/types';

interface MemorialFooterProps {
  company: Company | null;
}

export function MemorialFooter({ company }: MemorialFooterProps) {
  return (
    <footer className="py-8 bg-memorial-primary text-white/80">
      <div className="max-w-4xl mx-auto px-4 text-center">
        {company && (
          <div className="mb-4">
            {company.logoUrl ? (
              <img
                src={company.logoUrl}
                alt={company.name || 'Bestattungsinstitut'}
                className="h-12 mx-auto mb-3 brightness-0 invert opacity-80"
              />
            ) : (
              <div className="font-serif text-lg text-white/90 mb-1">
                {company.name}
              </div>
            )}
            <p className="text-sm text-white/60">
              Ein Service von {company.name}
            </p>
            {company.websiteUrl && (
              <a
                href={company.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-sm text-white/70 hover:text-white transition-colors mt-2"
              >
                <span>Website besuchen</span>
                <ExternalLink className="w-3 h-3" />
              </a>
            )}
          </div>
        )}

        <div className="border-t border-white/10 pt-6 mt-6">
          <p className="text-xs text-white/50 flex items-center justify-center gap-1">
            Gedenkportal erstellt mit <Heart className="w-3 h-3 text-red-400" /> und Respekt
          </p>
        </div>
      </div>
    </footer>
  );
}
